import { render, staticRenderFns } from "./ModalOsInterna.vue?vue&type=template&id=1197b610&"
import script from "./ModalOsInterna.vue?vue&type=script&lang=js&"
export * from "./ModalOsInterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports